"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var l = require("lenovo");
exports._isNull = function _isNull(param) {
    return param == null;
};
exports._noop = function () { };
/**
 * capitalize the string
 * @param str {string}
 * @return {string}
 */
exports._toCapitalize = function (str) {
    return str.slice(0, 1).toUpperCase() + str.slice(1).toLowerCase();
};
/**
 * valid the realms
 * @param realms {string|string[]}
 * @return {boolean}
 */
exports.validRealms = function (realms) {
    realms = [].concat(realms);
    var currentRealm = l.Common.getCurrentRealm();
    return realms.some(function (realm) {
        return exports._toCapitalize(realm) === l.RealmType[currentRealm];
    });
};
